import React from 'react';
import MoveBasicButton from '../Button/MoveBasicButton';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CompleteContent = ({ completeTxt }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get('type');

  const handleClick = () => {
    // 스타비트 결제 후에는 별도의 query string 있음 -> 스타비트내역 이동
    if (type === 'point') {
      navigate('/starbeat-history');
      // 그 외에는 구매내역으로 이동
    } else {
      navigate('/purchase-history');
    }
  };

  return (
    <div className={'complete-wrapper'}>
      <div className='icon-all-group'>
        <div className='icon-group'>
          <i className={'icon icon-check-wh'} />
        </div>
      </div>
      <div className='state-all-group'>
        <p className={'state-txt'}>{completeTxt}</p>
      </div>
      <div className='complete-button-group'>
        <MoveBasicButton buttonTxt={t('view_purchase_history')} onClick={handleClick} />
      </div>
    </div>
  );
};

export default CompleteContent;
